module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot/spot-258-c99e43ff41cf252143b96ba652be6a8c.jpg";